import React from 'react';

const MaterialSetOverviewRightMenu = () => {
  return <></>;
};

export default MaterialSetOverviewRightMenu;
